module.exports = __webpack_public_path__ + "static/media/db-tool.a3eb95dc.png";